import { getMoodsBasic } from '../util/api';

export const FETCH_MOODS_BASIC_REQUEST = 'app/moods_basic/FETCH_MOODS_BASIC_REQUEST';
export const FETCH_MOODS_BASIC_SUCCESS = 'app/moods_basic/FETCH_MOODS_BASIC_SUCCESS';
export const FETCH_MOODS_BASIC_ERROR = 'app/moods_basic/FETCH_MOODS_BASIC_ERROR';

export const initialState = {
  moods: [],
  isFetching: false,
  fetchError: null,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_MOODS_BASIC_REQUEST:
      return { ...state, isFetching: true, fetchError: null };
    case FETCH_MOODS_BASIC_SUCCESS:
      return { ...state, isFetching: false, moods: payload, fetchError: null };
    case FETCH_MOODS_BASIC_ERROR:
      return { ...state, isFetching: false, fetchError: payload };
    default:
      return state;
  }
}

// ================ Action creators ================ //

export const fetchMoodsBasicRequest = () => ({ type: FETCH_MOODS_BASIC_REQUEST });
export const fetchMoodsBasicSuccess = moods => ({
  type: FETCH_MOODS_BASIC_SUCCESS,
  payload: moods,
});
export const fetchMoodsBasicError = error => ({ type: FETCH_MOODS_BASIC_ERROR, payload: error });

// ================ Thunks ================ //

export const fetchMoodsBasicData = state => {
  return {
    moods: state.moodsBasic?.moods || [],
    isFetching: state.moodsBasic?.isFetching || false,
    fetchError: state.moodsBasic?.fetchError || null,
  };
};

export const fetchMoodsBasic = (params = {}) => async (dispatch, getState, sdk) => {
  dispatch(fetchMoodsBasicRequest());
  try {
    const result = await getMoodsBasic(params);
    dispatch(fetchMoodsBasicSuccess(result.moods || []));
    return result;
  } catch (error) {
    console.error('Error fetching moods basic:', error);
    dispatch(fetchMoodsBasicError(error.message || 'Failed to fetch moods basic'));
    throw error;
  }
};
